import React from "react";
import { UserActions } from "../store/actions/userAction";
import {  userInitialState } from "../store/userReducer";
import {UserState} from "../passapp-sdk/types/userTypes";

export const UserContext = React.createContext<{
  state: UserState;
  dispatch: React.Dispatch<UserActions>;
}>({
  state: userInitialState,
  dispatch: () => undefined,
});

export default UserContext;
